import {
  CheckResult,
  CheckResultStatus,
} from "../../../../reducers/uploadedBoard";
import Link from "next/link";
import { FakeLink } from "../../../../constants/Styles";
import Icon from "../../../common/Icon";
import { Result, ResultMessageContainer } from "./RuleChecksStyles";

export function PassIcon() {
  return <Icon src={"/icons/check_green.svg"} alt={"Pass"} />;
}
export function ErrorIcon() {
  return <Icon src={"/icons/error.svg"} alt={"Error"} />;
}
export function WarningIcon() {
  return <Icon src={"/icons/warn.svg"} alt={"Warning"} />;
}

export function ResultMessage({
  result,
  inspectResult,
}: {
  result: CheckResult;
  inspectResult?: () => void;
}) {
  return (
    <ResultMessageContainer>
      {result.message}
      {result.more_info_link && (
        <div>
          See{" "}
          <Link target={"_blank"} href={result.more_info_link}>
            here
          </Link>{" "}
          for more info.
        </div>
      )}
      {inspectResult !== undefined &&
        (result.locations !== null || result.shape_svg_url !== null) && (
          <FakeLink onClick={() => inspectResult()}>See details</FakeLink>
        )}
    </ResultMessageContainer>
  );
}

export default function ResultLine({
  result,
  inspectResult,
}: {
  result: CheckResult;
  inspectResult?: () => void;
}) {
  return (
    <Result>
      {result.status == CheckResultStatus.DISMISSED && <WarningIcon />}
      {result.status == CheckResultStatus.WARNING && <WarningIcon />}
      {result.status == CheckResultStatus.ERROR && <ErrorIcon />}
      <ResultMessage result={result} inspectResult={inspectResult} />
    </Result>
  );
}
